import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../_actions';

class AdminPage extends React.Component {
    render() {
        return (
            <div className="login col-md-6 col-md-offset-3">
                <h2 className="heading">Admin</h2>
                <form name="form" onSubmit={this.handleSubmit}>
                    <div className="form-group">
						<Link to="/register2" className="btn btn-link">New User Register</Link>							
                    </div>
                    <div className="form-group">
						<Link to="/delete" className="btn btn-link">Delete User</Link>							
                    </div>
                    <div className="form-group">
						<Link to="/deleteallanswersconfirm" className="btn btn-link">Delete All Answers</Link>							
                    </div>
                    <div className="form-group">
                        <Link to="/results" className="btn btn-link">Cancel</Link>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { registering } = state.registration;
    return {
        registering
    };
}

const connectedRegisterPage = connect(mapStateToProps)(AdminPage);
export { connectedRegisterPage as AdminPage };